import {Injectable, Inject} from 'ng-metadata/core';
import {ServiceDetailsService} from '../../search/fullView/details/serviceDetails.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {FilterInstitution} from '../../nddUtils/filterInstitution.service'
import {FilterLanguage} from "../../nddUtils/filterLanguage.service";
import {getVid} from '../../appConfig/appConfigForward';
import {HttpService} from '../../infra/httpRequest/http.service';
import { getInjectableName} from 'ng-metadata/core';
//let filter= require('lodash/filter');
const filter = require('lodash/filter');
const cloneDeep = require('lodash/cloneDeep');
const ESPLORO_SOURCE = '300';

@Injectable()
export class RepresentationViewerService {
	private vid: string= getVid();
	private results:Object;
	public primaBaseUrl:any;
	public updateStatsUrl:any;
	public updateDeliverySessionStatusUrl:any;
	private _inst: string=this.getInst();
	private ilsServices:object={};
private _repPid: string=this.getRepId();
private _showMainFile: Boolean=true;
private _showCopyrights: Boolean=false;
private _showThumbnailList: Boolean=true;
private _showMetadata: Boolean=true;
private _mobileMenuDisabled=true;
private _requestId:string ="";
private _sourceType:string ="";
private _mmsRes:string ="";
private _alreadyView: Boolean=false;
private _curRepId: string;
private _curSessionId: string;
private _openHour: string;
private _noNotification: Boolean;
private _curUserId: string;
private _isCDLRequest: Boolean;
private _cdlRequestId: string;

	constructor(private configurationUtil: ConfigurationUtil,
	private serviceDetailsService : ServiceDetailsService,
                @Inject('$state') private $state: ng.ui.IStateService,
				@Inject('restBaseURLs') private restBaseURLs,
				private httpService: HttpService,
                @Inject('$translate') private $translate,
                				  private filterInstitution: FilterInstitution,
	                 private filterLanguage: FilterLanguage) {
		this.primaBaseUrl = restBaseURLs.officeFileURL;
		this.updateStatsUrl=restBaseURLs.updateStatistics;
		this.clearDeliverySessionAtLogoutUrl=restBaseURLs.clearDeliverySessionAtLogout;
		this._alreadyView = false;
		this.ilsServices = {
        'officeFile': {
            'path': this.primaBaseUrl,        
            'method': 'GET'
		},
		'updateStatistics': {
            'path': this.updateStatsUrl,        
            'method': 'GET'
		},
		'clearDeliverySessionAtLogout':{
			'path': this.clearDeliverySessionAtLogoutUrl,
			'method': 'GET'
		}
	};
		
		
			}
			

private resquestInProgress:Object = {};
private parseFilesDisplay(files,iiifJwtToken,serverlessIiif){
	    let filesArray= [];
	    let i=0;
	    files.forEach((file)=>filesArray.push(this.parseFileDisplay(file,i++,iiifJwtToken,serverlessIiif)));
	    return filesArray;
	}
	private getInst() {
		if (this.$state.params['vid'] != null){
		return  this.$state.params['vid'].split(':')[0];
		}
		else{
			return  appConfig.vid.split(':')[0];
		}
	} 
	 get currentVid(){
	   	if (this.$state.params['vid'] != null){
		return  this.$state.params['vid'];
		}
		else{
			return  appConfig.vid;
		}
   	}
	 private parseFileDisplay(file,i,iiifJwtToken,serverlessIiif){
		var extension = '';
		var inst = '';
		if (file.fileType != 'ESPLORO_LINK') {
			var filename = file.path;
			extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || '';
			inst = file.path.split('/')[0];
		}
		var shortLabel=file.label;
		if (file.label.length > 25) {
   		  shortLabel = file.label.substring(0, 25) + "...";
		}
		var midLabel=file.label;
		if (file.label.length > 70) {
   		  midLabel = file.label.substring(0, 70) + "...";
		}
		var mediaJs=this.getMediaJs(file);
		
		let filesDisplay={
			fileId: file.pid,
			fileSize:file.size,
			fileOrigSize: file.fileSize,
			fileLabel:file.label,
			fileShortLabel:shortLabel,
			fileMidLabel:midLabel,
			thumbnail_url:file.thumbnail_url,
			hasThumbnail:file.hasThumbnail,
			url:file.url,
			downloadUrl: file.downloadUrl,
			inst: inst,
			extension:	extension,
			contentType:file.contentType,
			fileType:file.fileType,
			cfPolicy:file.cfPolicy,
			cfSignature: file.cfSignature,
			cfKP: file.cfKP,
			index:i,
			isAccessRightsOk: file.isAccessRightsOk,
			deniedMessage: file.deniedMessage,
			fulltext: file.fulltext,
			media:mediaJs,
			requiresPDFCoverPage: file.requiresPDFCoverPage,
			idUrl: file.idUrl,
			height: file.height,
			width: file.width,
			format: file.format,
			iiifJwtToken: iiifJwtToken,
			serverlessIiif: serverlessIiif
			};
		return filesDisplay;
	}   
	private getMediaJs(file){
	 let mediaJs= {
            sources: [
                {
                    src: file.url,
                    type: file.contentType
                }
            ]};
			if (file.captions!=undefined){
	 				var tracks=[];
					  for(let i=0; i< file.captions.length; i++){
					    let langlabel = this.$translate.instant('repDeliveryViewer.al.captionsOn');
					    if (file.captions[i].language!=undefined){
				      		langlabel=this.$translate.instant('lang.'+file.captions[i].language);
					    }
				    tracks.push({
					     kind: 'captions',
					     src: file.captions[i].url,
					     label:langlabel,
					     default: file.captions[i].isDefault
				    });
			  }
            mediaJs.tracks=tracks;
			 }
		return mediaJs;
	}
	
    	private getRequestId() {
    	return this._requestId;
    	}
        public    setRequestId(reqId){
    this._requestId=reqId;
	}
	
	private getSourceType() {
    	return this._sourceType;
    	}
        public    setSourceType(sourceType){
    this._sourceType=sourceType;
    }

    private getMmsRes() {
    	return this._mmsRes;
    	}
        public    setMmsRes(mmsid){
    this._mmsRes=mmsid;
    }
	private getRepId() {
    	return  this.$state.params['repId'];
    } 
   	getDetails() {
   	 return this.results;
   	}
 get isShowMainFile(){
    	return this._showMainFile;
    }
    get isShowCopyrights(){
    	return this._showCopyrights;
    }
    get isShowThumbnailList(){
    	return this._showThumbnailList;
    }
     get isShowMetadata(){
    	return this._showMetadata;
    	}
    	 get isMobileMenuDisabled(){
    	return this._mobileMenuDisabled;
    }
     public setMobileMenuDisabled(mobileMenuDisabled){
    this._mobileMenuDisabled=mobileMenuDisabled;
    }
   public setShowMainFile(show){
    this._showMainFile=show;
    }
    public   setShowCopyrights(show){
    this._showCopyrights=show;
    }
    public setShowThumbnailList(show){
    this._showThumbnailList=show;
    }
    public    setShowMetadata(show){
    this._showMetadata=show;
    }
	setDetails(res) {
		let details= this.parseDetails(res);
		if (details){
       		this.results = details.filter((detail)=>{
        	if (detail.values!=null){
            	for(let i=0; i< detail.values.length; i++){
                	let value= detail.values[i];
                	value= this.getValuesOfValueItems(value);
                	return value.length >0;
           		}
         	}
        	});
		}
	}
	 private parseDetails(res) {
		return this.configurationUtil.getFullViewConfiguration().resultitemview.map((item)=>this.serviceDetailsService.parseItem(res,item,true, undefined));
	}
	 getValuesOfValueItems(value){
       let filterData= this.filterInstitution.filterAndNormalizeData(value, value.values);
         filterData = this.filterLanguage.filterField(filterData);
        return filterData;
    } 
  public getRepresentationInfo(officeUrl){
	let params = {
		inst: this._inst,
		url: officeUrl
	};
	return this.makeIlsRequest('officeFile', params);
   }	
 public updateStatistics(fileId,action){
	 if (this.isEsploroRecord()){
		if (action === 'VIEW' || action === 'DOWNLOAD'){
			action = 'SPECIFIC_FILE_REQUEST';
			if (!this._alreadyView){
				this.updateStatistics(fileId, 'FILE_REQUEST');
			}
		}
		else if (action === 'FILE_REQUEST'){
			this._alreadyView = true;
			fileId = this._mmsRes; 
			}
	 	}
		let params = {
			repId: this._repPid,
            mmsId:this._mmsRes,
            pid:fileId,
			inst: this._inst,
			type:action,
			requestId:this._requestId
			
		};
        return this.makeIlsRequest('updateStatistics', params);
   }
   
   private ilsRequestSuccess(response){
	return response; 
}
private ilsRequestFailure(reason, serviceName, params) {
	console.error(reason, serviceName);
	return reason;   
}
   makeIlsRequest(serviceName: string, params: Object){
	if(!params){
		params= {};
	}
	let serviceDetails = this.ilsServices[serviceName];
	this.resquestInProgress[serviceName] = true;

	return this.httpService.call(serviceDetails.method, serviceDetails.path, params)
		.then(
			(response)=> {
				return this.ilsRequestSuccess(response);
			},
			(error)=>{
				return this.ilsRequestFailure(error, serviceName, params);
			}
		).finally( () =>
			this.resquestInProgress[serviceName] = false
		);
}

        public showMainFile(){
      		let copyrights = document.getElementsByTagName('prm-copyrights') as HTMLCollectionOf<HTMLElement>;
        		let mainFile = document.getElementsByClassName('main-file') as HTMLCollectionOf<HTMLElement>;
        		let mainPage = document.getElementsByClassName('main-page') as HTMLCollectionOf<HTMLElement>;
        		let thumbnailList = document.getElementsByClassName('thumbnail-list') as HTMLCollectionOf<HTMLElement>;
        		let metadataComponent=document.getElementsByClassName('md-list') as HTMLCollectionOf<HTMLElement>;
        			let downloadButton =  document.getElementsByClassName('downloadButton') as HTMLCollectionOf<HTMLElement>;
        		let left=false;
        		this._showCopyrights=false;  
        			this._showThumbnailList=false; 
        			this._showMetadata=false; 
         			   if (thumbnailList.length != 0) {
        						left=true;					
         				}     			
        			
        				let activeButtons=document.getElementsByClassName('active-button') as HTMLCollectionOf<HTMLElement>;
  	      		let inactiveButtons=document.getElementsByClassName('inactive-button') as HTMLCollectionOf<HTMLElement>;
  				for (let i=0;i<activeButtons.length;i++){
  					activeButtons[i].style.display = "none";
  					inactiveButtons[i].style.display = "block";
  					if (activeButtons[i].getAttribute('icon-definition')==="ic_image_mobile_active_24px"){
  						activeButtons[i].style.display = "block";
  					}
  					if (inactiveButtons[i].getAttribute('icon-definition')==="ic_image_mobile_24px"){
  						inactiveButtons[i].style.display = "none";
  					}
  				}
        			//	if (left===true){
      				//	mainFile[0].classList.remove('animate-right');
      				//	mainFile[0].classList.add('animate-left');
      				//}
      				//else{
      				//	mainFile[0].classList.remove('animate-left');
      				//	mainFile[0].classList.add('animate-right');
      				//}
						if (downloadButton.length != 0){
      					downloadButton[0].style.display = "block"
      				}
         			this._showMainFile=true; 
        				if (mainPage.length != 0) {
        					mainPage[0].classList.add('showIfXs');
        					mainPage[0].classList.remove('hide');
        				}
		  }
		  
		  public isEsploroRecord() :boolean {	
			return this._sourceType === ESPLORO_SOURCE;

		}
   
   public setCurSessionId(sessionId) {
       this._curSessionId = sessionId;
   }
   
   
   public getCurSessionId() {
       return this._curSessionId;
   }
   
   public setOpenHour(openHour) {
       this._openHour = openHour;
   }
   
   
   public getOpenHour() {
       return this._openHour;
   }
   
   public setNoNotification(noNotification) {
       this._noNotification = noNotification;
   }
   
   
   public getNoNotification() {
       return this._noNotification;
   }
   
   public setCurUserId(userId) {
       this._curUserId = userId;
   }
   
   
   public getCurUserId() {
       return this._curUserId;
   }

   // for some reason, when logging out the _repId is null, 
   // need to use another variable for current Rep ID
   public setCurRepId(repId) {
       this._curRepId = repId;
   }
   
   
   public getCurRepId() {
       return this._curRepId;
   }
   
   public setIsCDLRequest(isCDLRequest) {
       this._isCDLRequest = isCDLRequest;
   }
   
   public getIsCDLRequest() {
       return this._isCDLRequest;
   }
   
   public setCDLRequestId(cdlRequestId) {
       this._cdlRequestId = cdlRequestId;
   }
   
   public getCDLRequestId() {
       return this._cdlRequestId;
   }
   
   public clearDeliverySessionAtLogout() {      
		let params = {
			repId: this.getCurRepId(),
            sessionId: this.getCurSessionId(),
            userId: this.getCurUserId(),
            openHour: this.getOpenHour(),
            noNotification: this.getNoNotification(),
			inst: this._inst,
			isCdlRequest: this.getIsCDLRequest(),
			cdlRequestId: this.getCDLRequestId()
			
		};
        return this.makeIlsRequest('clearDeliverySessionAtLogout', params);
   }
   
   
   public updateCurFileLabel(index, label) {
        var fileLabelElement = document.getElementById("file_label_"+index.toString());
    	if (fileLabelElement != undefined && fileLabelElement != null) {
	    	let fileLabelElementWidth: number = fileLabelElement.offsetWidth;
	    	// the number 0.101 is an estimate from experiment the width on desktop
	    	let maxChar: number = Math.round(fileLabelElementWidth * 0.101);
    		angular.element(fileLabelElement).text(this.adjustTitleOrLabel(label, maxChar));
    	}      
   }
   
   public checkAndTruncateTitleAndLabel(metadataTitle) {
        if (metadataTitle == undefined || metadataTitle == null) {
            return "";
        }
        var toolbarTitleElement = document.getElementById("toolbar-title");
        var updatedTitle = metadataTitle;
        // only for non-mobile, we would have tool bar title by now
        if (toolbarTitleElement != undefined && toolbarTitleElement != null) {
            let toolbarTitleWidth: number = toolbarTitleElement.offsetWidth;
            // the number 0.101 is an estimate from experiment the width on desktop
            let maxChar: number = Math.round(toolbarTitleWidth * 0.09);
            updatedTitle = this.adjustTitleOrLabel(updatedTitle, maxChar);
        }
        return updatedTitle;
    }

   
   
   public adjustTitleOrLabel(titleOrLabel, maxChar) {
    	var updatedTitleOrLabel = titleOrLabel;
    	var indx = 0;
    	var line1 = updatedTitleOrLabel;
    	var line2 = "";
    	var line3 = "";
    	// find a word breaking point by looking at the last blank character
    	// if no blank character, break word per maxChar
	    if (line1.length > maxChar) {
	    	line1 = line1.substring(0, maxChar);
	    	indx = line1.lastIndexOf(" ");
	    	if (indx < 0) {
	    		// no last blank, truncate according to maxChar	    		
		    	line1 = line1.substring(0, maxChar);
		    	line2 = updatedTitleOrLabel.substring(maxChar);	    		
	    	} else {
		    	line1 = line1.substring(0, indx + 1);
		    	line2 = updatedTitleOrLabel.substring(indx +1);
		    }
	    }
	    // line 2 if there is anything
	    if (line2.length > maxChar) {
	    	line2 = line2.substring(0, maxChar);
	    	indx = line2.lastIndexOf(" ");
	    	if (indx < 0) {
	    		// no last blank, truncate according to maxChar	    		
		    	line2 = line2.substring(0, maxChar);    		
	    	} else {
		    	line2 = line2.substring(0, indx);
		    }
	    	// add the three dots only when title or label is too long
	    	// fit the three dots at the end of the second line
	    	if (line2.length + 4 > maxChar) {
	    		indx = line2.lastIndexOf(" ");
		    	if (indx > 0) {
			    	line2 = line2.substring(0, indx);
			    } else if (line2.length > 4) {
			    	line2 = line2.substring(0, line2.length - 4);
			    } else {
			    	line2 ="";
			    }
	    	}
	    	line3 =" ..."	    	
	    }
	    return line1 + line2 + line3;    
    }
   
   
}
//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/delivery/representationViewer/representationViewer.service.ts